import { IconButton, Tooltip, Grid } from '@mui/material'
import { metodoPrograma } from '../../../components/api'
import Programa from '../../../components/Programa/Programa'
import { isEqual } from 'lodash'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'

const PerfilPerfmissao = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [programaAberto, setProgramaAberto] = useState([])
  const [contratanteSelecionado, setContratanteSelecionado] = useState(0)
  const [tipoUsuario, setTipoUsuario] = useState(undefined)
  const [refreshUsuario, setRefreshUsuario] = useState(0)

  const exclui = useCallback(
    (dadosAtendimento) => {
      const dados = {
        idPerfil: dadosAtendimento[0],
        idContratante: dadosAtendimento[1][0][0],
        idTipoUsuario: dadosAtendimento[2][0][0],
      }
      metodoPrograma('exclui', dados).then((res) => {
        if (res.status) {
          setRefreshUsuario((prev) => prev + 1)
        }
      })
    },
    [setRefreshUsuario],
  )

  useEffect(() => {
    switch (tela) {
      case 'usuario':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton
              onClick={() => {
                setProgramaAberto([])
                setTela('edicao')
              }}
            >
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  const voltar = () => {
    setTela('lista')
    setProgramaAberto(undefined)
  }

  const handleClick = (linha) => {
    const dados = {
      ...linha,
      tipoUsuario,
      contratanteSelecionado,
    }
    setProgramaAberto(dados)
    setTela('edicao')
  }

  const handleContratante = (linha) => {
    setContratanteSelecionado(linha)
    setTela('usuario')
  }

  return (
    <Programa codigo="PerfilPermissao" ferramentas={ferramentas}>
      {tela === 'lista' && (
        <PrimeTable
          codigo="PerfilPermissao"
          action="listaContratante"
          rows={10}
          collumnsDateHour={[3, 4]}
          head={['ID', 'Nome', 'Inclusão', 'Exclusão']}
          line={(l) => [l[0], l[1], l[2], l[3]]}
          onRowSelect={handleContratante}
        />
      )}
      {tela === 'usuario' && (
        <>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            {contratanteSelecionado && (
              <AutoComplete
                InputLabelProps={{ shrink: true }}
                label="Tipo de Usuário"
                metodo="listaTiposUsuario"
                searchParams={{ idContratante: contratanteSelecionado?.[0] }}
                onChange={(_, v) => {
                  setTipoUsuario(v)
                  setRefreshUsuario((prev) => prev + 1)
                }}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {tipoUsuario && (
              <PrimeTable
                codigo="PerfilPermissao"
                action="lista"
                rows={10}
                collumnsDateHour={[3, 4]}
                head={[
                  'Perfil',
                  'Contratante',
                  'Tipo Usuário',
                  'Inclusão',
                  'Exclusão',
                ]}
                line={(l) => [l[3], l[1][1], l[2][1], l[4], l[5]]}
                onDelete={{ index: 4, action: exclui }}
                onRowSelect={handleClick}
                refresh={refreshUsuario}
                parametros={{
                  idContratante: contratanteSelecionado[0],
                  idTipoUsuario: tipoUsuario?.[0]?.[0],
                }}
              />
            )}
          </Grid>
        </>
      )}
      {tela === 'edicao' && (
        <Edicao
          {...{
            programaAberto,
            setTela,
            tipoUsuario,
            contratanteSelecionado,
            setRefreshUsuario,
          }}
        />
      )}
    </Programa>
  )
}

export default memo(PerfilPerfmissao, isEqual)
